import React from "react";
import PropType from "prop-types";
import "./fadeInSection.css";
import { useInView } from "react-intersection-observer";

export default function FadeInSection(props) {
  const { ref, inView } = useInView({
    triggerOnce: false,
  });

  return (
    <section
      ref={ref}
      className={
        inView || props.first ? "fade-in-section is-visible" : "fade-in-section"
      }
    >
      {props.children}
    </section>
  );
}

FadeInSection.propTypes = {
  children: PropType.arrayOf(PropType.node).isRequired,
  first: PropType.bool,
};
